export default __webpack_public_path__ + "static/media/live.5bd6962e.svg";